import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-mangopay-sca-validation',
  templateUrl: './mangopay-sca-validation.component.html',
  styleUrls: ['./mangopay-sca-validation.component.scss'],
})
export class MangopayScaValidationComponent implements OnInit {

  @Output() public finishEvent = new EventEmitter<any>();

  urlSafe: SafeResourceUrl;
  iframeLoaded: boolean = false;
  step: number = 0;

  text: string;
  image: number;
  btnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  loading: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.profileService.categorizeUser().subscribe(resp => {
      if (resp === 'Categorized') {
        this.setValidatedMessageParams();
        this.step = 1;
      } else {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resp);
      }
      this.cdRef.detectChanges();
    });

    window.addEventListener('message', e => {
      if (e.data.func === 'control_status') {
        const status = e.data.data.value.controlStatus;
        let result;

        this.step = 1;
        this.loading = true;
        if (status === 'VALIDATED') {
          this.setValidatedMessageParams();
          result = true;
        } else {
          this.image = 1;
          this.text = this.translate.instant('SCA.ISSUE');
          result = false;
        }

        this.profileService.saveCategorizeResult(result).subscribe(() => {
          this.loading = false;
          this.finish();
          this.cdRef.detectChanges();
        });
      }
      this.cdRef.detectChanges();
    });
    this.cdRef.detectChanges();
  }

  charged(event) {
    setTimeout(() => {
      this.iframeLoaded = true;
      this.cdRef.detectChanges();
    }, 1000);
    this.cdRef.detectChanges();
  }

  setValidatedMessageParams() {
    this.image = 6;
    this.text = this.translate.instant('SCA.CAN_CONTINUE');
    this.cdRef.detectChanges();
  }

  finish() {
    this.finishEvent.emit();
    this.cdRef.detectChanges();
  }

}
